import Highcharts from 'highcharts';

export default
{
    legend: {
        layout: 'vertical', align:'center', verticalAlign: 'bottom',
        enabled:false,
        useHTML: true,

    },
    credits: {
        enabled:false
    },
    chart: {
        type: 'spline',
        animation: false,
        height: '450px',
    },
    title: {
        text: null,
        useHTML: true
    },
    subtitle: {
        text: null,
        useHTML: true
    },
    xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: {
            month: '%e. %b',
            year: '%b',
            hour: '%H:%M'
        },
        gridLineWidth: 1,
        gridLineColor: 'rgba(200,200,200,0.3)',
        lineColor: '#000',
        lineWidth: 1,
        tickColor: '#000',

        tickInterval: 12 * 60 * 60 * 1000,

        minorGridLineColor: 'rgba(8,8,8,0.3)',
        gridLineDashStyle: 'Dot',

        labels: {
            rotation: -90,
            y:20
        },
        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,



    },
    yAxis: [{
        min: 0,
        opposite: true,
        // max: max_y,

        title: {
            enabled: false,
        },

        minorTickInterval: 50,
        minorGridLineWidth:1,
        minorGridLineColor: 'rgba(200,200,200,0.1)',
        gridLineColor: 'rgba(200,200,200,0.2)',

        lineColor: '#000',
        lineWidth: 1,
        tickWidth: 1,
        //tickInterval: 100,
        tickColor: '#000',
        plotBands:[],
        plotLines:[],

    },
        {
            title: {
                enabled: false,
            },
        }],
    tooltip: { shared: true, useHTML:true},
    plotOptions: {
        spline: {
            showInLegend: true,
            animation: false,
            events: {
                legendItemClick: function () {
                    return false;
                }
            },
            marker: {
                enabled: false,
                symbol: 'circle',
                radius: 2,
                states: {
                    hover: {
                        enabled: true,
                        lineWidthPlus: 2
                    }
                }
            },
            states: {
                hover: {
                    enabled: true,
                    lineWidthPlus: 0
                }
            }
        },
        scatter: {
            showInLegend: true,
            animation: false,
            events: {
                legendItemClick: function () {
                    return false;
                }
            },
            tooltip: {
                pointFormatter: function () {
                    var point = this;
                    return '<small>' + Highcharts.dateFormat('%e. %B %Y', new Date(point.x)) + '</small>: <b>' + point.y + ' µg/m<sup>3</sup></b>';
                },
                shared: false,
            },
            states: {hover: {enabled: false}},
            marker: {
                symbol:'circle',
                fillOpacity:0.8,
                lineColor:'#000000',
                lineWidth:0.5,
                radius:10,
                states: {hover:{enabled:false}}
            },
        },
        states:{
            hover:{
                enabled:true
            }
        },
        series: {
            animation: false,
            states:{
                inactive: {
                    opacity: 1
                }
            },

        }
    },
    series: [
        {
            id:'m',
            name:'Koncentrácia',
            type: 'spline',
            zIndex:3,
            color:'#ff6c00',
            lineWidth:2,
            tooltip: { valueSuffix: ' &micro;g/m<sup>3</sup>' },
            data:[]
        },
        {
            id:'pm10_12h',
            name:'12-h kĺzavý priemer PM<sub>10</sub>',
            type: 'spline',
            zIndex:2,
            color:'#6A9FF6',
            lineWidth:2,
            tooltip: { valueSuffix: ' &micro;g/m<sup>3</sup>' },
            data:[]
        },
        {
            id: 'pm10_dpr',
            name: 'Denný priemer PM<sub>10</sub>',
            type: 'scatter',
            zIndex: 1,
            color: '#bbbbbb',
            tooltip: {valueSuffix: ' &micro;g/m<sup>3</sup>', enabled: false},
            data: [],
        }
    ]
}
